export const API = {
  USER_ENDPOINT: "/api/user",
  PROGRAM_ADVANCE_ENDPOINT: "/api/program/advance",
};
